export enum MediaMode {
    WEB = 'web',
    KIOSK = 'kiosk'
}

export interface DisplayModeInterface {
    displayMode: MediaMode;
    place?: string | null;
}
